import { ChaveTema } from "@/components/casca/ChaveTema";

/**
 * Tema escuro, ligado ou desligado — a mesma chave do pé do menu.
 *
 * Preferência do NAVEGADOR, não da conta: a recepção e a dona da clínica
 * podem querer coisas diferentes na mesma conta, e quem decide é quem está
 * olhando a tela. Enquanto ninguém mexe na chave, o painel segue o aparelho.
 */
export function Aparencia() {
  return (
    <div className="flex items-center gap-4">
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-[var(--color-tinta)]">Tema escuro</p>
        <p className="text-xs text-[var(--color-suave)]">Cinza-chumbo, mais confortável para quem passa horas no painel.</p>
      </div>
      <ChaveTema />
    </div>
  );
}
